import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const studyRealtimeListeners: SocketEventListener[] = [
  {
    event: 'studyEvent',
    handler: (msg: any) => {
      console.log('socket io - studyEventListener', msg);
      emitter.emit(EMITTER_CONSTANTS.STUDY_EVENT, msg);
    },
  },
  {
    event: 'studyUpdated',
    handler: (msg: any) => {
      console.log('socket io - studyUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.STUDY_UPDATED_EVENT, msg);
    },
  },
  {
    event: 'studyDeleted',
    handler: (msg: any) => {
      console.log('socket io - studyDeletedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.STUDY_DELETED, msg);
    },
  },
  {
    event: 'newEvaluationStrip',
    handler: (msg: any) => {
      console.log('socket io - newEvaluationStripListener', msg);
      emitter.emit(EMITTER_CONSTANTS.NEW_EVALUATION_STRIP, msg);
    },
  },
  {
    event: 'artifactStudiesUpdated',
    handler: (msg: any) => {
      console.log('socket io - artifactStudiesUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.ARTIFACT_STUDIES_UPDATED, msg);
    },
  },
  {
    event: 'StudyPricingUpdated',
    handler: (msg: any) => {
      console.log('socket io - studyPricingUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.STUDY_PRICING_UPDATED, msg);
    },
  },
  {
    event: 'deviceStartedStudy',
    handler: (msg: any) => {
      console.log('socket io - deviceStartedStudyListener', msg);
      emitter.emit(EMITTER_CONSTANTS.DEVICE_STARTED_STUDY, msg);
    },
  },
];

export default studyRealtimeListeners;
